<div>
	<span>&copy; {{ LANGUAGE.translate("@@business-name") }} {{ DATE.now.year }}</span>
</div>